import { g } from "analytics";
import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { clog } from "log";
import { initReactI18next } from "react-i18next";
import { Consts } from "vars";
import de_path from "./i18n/de.json";
import en_path from "./i18n/en.json";
import es_path from "./i18n/es.json";
import fr_path from "./i18n/fr.json";
import zh_path from "./i18n/zh.json";
const LANGUAGE_FILE_MAP = {
    "en": en_path,
    "es": es_path,
    "fr": fr_path,
    "de": de_path,
    "zh": zh_path,
};
const missingKeysLogged = {};
const ignoreList = [
    "0", "1", "2", "Google", "Microsoft", "Twitter", "L", "M", "XS", "S", "XL", "3D",
    "3", "4", "5", "6", "7", "8", "9", "0", "ChemText",
];
i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
    load: "languageOnly",
    supportedLngs: ["en", "es", "fr", "de", "zh"],
    backend: {
        loadPath: (lng, ns) => {
            return LANGUAGE_FILE_MAP[lng];
        },
    },
    fallbackLng: "en",
    interpolation: {
        escapeValue: false // react already safes from xss
    },
    returnEmptyString: false,
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key, fallbackValue, updateMissing, options) => {
        if (key in missingKeysLogged) {
            return;
        }
        if (ignoreList.indexOf(key) > -1) {
            return;
        }
        // Ignore search terms
        if (key.indexOf(".search") > -1 && key.indexOf("apparatus.") > -1) {
            return;
        }
        if (Consts.isDev) {
            clog("Missing key: " + key);
        }
        else {
            g("MissingTranslationKey", key);
        }
        missingKeysLogged[key] = true;
    }
});
export default i18n;
